import { EnqueueSnackbar, enqueueSnackbar } from "notistack";
import { APIRoutes } from "../../../constants";
import { RequestServer } from "../../../utils/services";
import {
  setDialogTypes,
  setProjectDetailsDefaultValues,
} from "../../../pages/Projects/types";
import { Dispatch, SetStateAction } from "react";

export interface iconTypes {
  logNewCall: boolean;
}

export type ProjectWarning = {
  isOpen: boolean;
  action: "Reopen" | "Close" | null;
};

export type SetProjectWarning = Dispatch<SetStateAction<ProjectWarning>>;

export enum CLIENT_NAMES {
  MCKINSEY='McKinsey',
}

export enum PROJECT_STATUS {
  OPEN = 'Open',
}

export const reopenCloseProject = async (
  id: string,
  action: "Reopen" | "Close",
  enqueueSnackbar: EnqueueSnackbar,
  setLoading: (b: boolean) => void,
  setDefaultValues: setProjectDetailsDefaultValues,
  setProjectWarning: SetProjectWarning
) => {
  const payload = {
    id: parseInt(id),
    action,
  };

  setLoading(true);
  try {
    const response = await RequestServer(APIRoutes.projects, "PATCH", payload);

    if (response.success) {
      const msg =
        action === "Close"
          ? "Project is Successfully Close"
          : "Project is Successfully Reopened";

      enqueueSnackbar(msg, {
        variant: "success",
      });

      const status = action === "Close" ? "Closed" : "Open";
      // changing project status
      setDefaultValues((prev: any) => ({
        ...prev,
        projectDetails: {
          ...prev.projectDetails,
          status,
        },
      }));
      handleClose(setProjectWarning);
    } else {
      enqueueSnackbar(response.message, {
        variant: "warning",
      });
    }
  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false);
  }
};

export const handleClose = (setProjectWarning: SetProjectWarning) => {
  setProjectWarning((prev) => ({ action: null, isOpen: false }));
};
